export enum RepositoryStrategyType {

    Postgres = 'POSTGRES',
    Hybrid = 'HYBRID'

}
